/**
 * User-facing messages for every error code the browser auth routes return,
 * both as `authError` redirect codes and as JSON `error` fields.
 */
const authErrorMessages: Record<string, string> = {
  // Redirect codes from /auth/callback and /auth/logged-out.
  auth_unavailable: 'Browser sign-in is temporarily unavailable. Please try again later.',
  auth_failed: 'The sign-in attempt could not be completed safely.',
  auth_cookie_absent: 'This sign-in was not started in this browser, or its cookie was blocked. Please start again.',
  auth_cookie_duplicate: 'Conflicting sign-in cookies were sent. Clear the cookies of this site and try again.',
  auth_cookie_malformed: 'The sign-in cookie could not be read. Clear the cookies of this site and try again.',
  login_rejected: 'This sign-in response does not belong to a sign-in started in this browser.',
  login_expired: 'This sign-in attempt expired. Please start again.',
  state_rejected: 'The sign-in response could not be verified.',
  provider_rejected: 'The identity provider rejected or could not complete sign-in.',
  identity_not_bound: 'This identity is not yet bound to a foss.global account.',
  session_failed: 'A secure browser session could not be created.',
  logout_rejected: 'The sign-out response could not be verified.',
  logout_expired: 'The sign-out took too long to return to foss.global. Your foss.global session had already ended.',
  // JSON error codes from /auth/login, /auth/session and /auth/logout.
  browser_auth_unavailable: 'Browser sign-in is temporarily unavailable. Please try again later.',
  origin_rejected: 'The request did not come from this site.',
  csrf_rejected: 'Your session could not confirm this request. Reload the page and try again.',
  request_body_rejected: 'The request was malformed.',
  return_target_rejected: 'The page to return to after sign-in is not allowed.',
  authentication_required: 'Your session has ended. Please sign in again.',
  session_refresh_in_progress: 'Your session is being renewed. Please try again in a moment.',
  session_refresh_uncertain: 'Your session could not be renewed reliably. Please sign in again.',
  browser_auth_failed: 'The sign-in service failed. Please try again.',
  not_found: 'Browser sign-in is not available on this deployment.',
};

const fallbackMessage = 'The sign-in attempt could not be completed safely.';

export const describeAuthError = (codeArg: string): string =>
  Object.hasOwn(authErrorMessages, codeArg)
    ? authErrorMessages[codeArg]
    : fallbackMessage;
